/**
 * FLOOR-TO-FLOOR HEIGHTS ARE ASSUMED, NOT MEASURED.
 *
 * NAMA's profile draws مطل in plan only — no section, no elevation, no level
 * marks — so nothing in Madar says how tall a storey is. These are typical
 * figures for a waterfront food-and-beverage block: a taller ground floor for
 * the plaza frontage, standard storeys above. Change them here; every slab,
 * core, label and camera preset is derived from this table.
 */
export const FLOOR_HEIGHTS_M: Record<string, number> = {
  ground: 5.0,
  first: 4.2,
  second: 4.2,
  third: 4.2,
};

/** Structural slab drawn at the foot of each storey. Also assumed. */
export const SLAB_M = 0.35;

/** Gap added between storeys at full explode, in metres. */
export const EXPLODE_GAP_M = 9;

export const KIND_AR: Record<string, string> = {
  restaurant: 'مطعم',
  coffee_shop: 'مقهى',
  kiosk: 'كشك',
  office: 'مكاتب',
  other: 'أخرى',
};
